import script from "./ApprovalDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalDetailModal.vue?vue&type=style&index=0&id=7ccf4448&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ccf4448"]])

export default __exports__